import React from 'react';
import loadable from '@loadable/component';

import { withError } from '../../../shared/components/error-boundary';

const loadableComponents = {
    'bundles': loadable(() => import(`./bundles`)),
    'server': loadable(() => import(`./server`)),
    'sustainability': loadable(() => import(`./sustainability`)),
}

function IconMapper({ name, size }) {
    const Icon = loadableComponents[name] || loadable(() => import(`./${name}`));
    return <Icon size={size} />;
}

export default withError(IconMapper);
